import React, { forwardRef } from 'react';
import { NumericFormat } from 'react-number-format';
import { NumberFormatComponentProps, NumberFormatWhileTypingProps } from './NumberFormatWhileTyping.props';

const NumberFormatWhileTyping = forwardRef<HTMLInputElement, NumberFormatComponentProps>((props, ref) => {
  const { onChange, name, inputRef, ...other } = props;
  const inputRefValue = inputRef ?? ref;

  const handleOnValueChange = (values: { value: string }) => {
    if (onChange) {
      const event = {
        target: {
          name: name ?? '',
          value: values.value,
        },
      };

      onChange(event as React.ChangeEvent<HTMLInputElement>);
    }
  };

  const numericFormatProps = Object.entries(other).reduce((acc, [key, value]) => {
    if (!['children', 'ref'].includes(key)) {
      acc[key] = value;
    }
    return acc;
  }, {} as NumberFormatWhileTypingProps);

  return (
    <NumericFormat
      {...numericFormatProps}
      getInputRef={inputRefValue}
      onValueChange={handleOnValueChange}
      thousandSeparator
      valueIsNumericString
    />
  );
});

export default NumberFormatWhileTyping;
